import { useEffect } from 'react';
import { profileActions } from '@figure/frontlib-onboarding-redux';
import useRedux from './useRedux';

/**
 * Fetches profile and returns profile reducer and actions.
 *
 * @param {Boolean} shouldFetch Whether to fetch the profile.
 */
const useProfile = (shouldFetch = true) => {
  const profileStateAndActions = useRedux('profileReducer', profileActions);
  const { getProfile } = profileStateAndActions;

  useEffect(() => {
    if (shouldFetch) getProfile();
  }, [shouldFetch, getProfile]);

  return profileStateAndActions;
};

export default useProfile;
